import { useMemo } from 'react';
import { HasStartEndDate, formatVacancyDates } from './formatVacancyDates';

export const useVacancyDates = ({ startedAt, endedAt }: HasStartEndDate) => {
  return useMemo(() => formatVacancyDates({ startedAt, endedAt }), [startedAt, endedAt]);
};
